export default __webpack_public_path__ + "static/media/gzlogo1.477cd847.png";